import {UseQueryOptions, useQuery} from '@tanstack/react-query';
import {AxiosResponse} from 'axios';
import {axiosBffFetch} from '../../../axios/axiosBffFetch';
import {AskListData, AskListRequestParams, AskListResponse} from '../type';

const useAskListQueryHook = ({
  variables,
  options,
}: {
  variables: AskListRequestParams;
  options?: UseQueryOptions<AskListData | null>;
}) =>
  useQuery<AskListData | null>({
    queryKey: useAskListQueryHook.getKey(variables),
    queryFn: async () => {
      const params = new URLSearchParams({
        current: variables.current.toString(),
        rowsPerPage: variables.rowsPerPage.toString(),
        projectId: variables.projectId,
      });

      const result: AxiosResponse<AskListResponse> = await axiosBffFetch(
        `/api/ask/list?${params.toString()}`
      );
      return result.data.data;
    },
    ...options,
  });

useAskListQueryHook.getKey = (variables: AskListRequestParams) => [
  'askList',
  variables,
];

export default useAskListQueryHook;
